import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23bf5eef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn btn-secondary btn-icon btn-lg" }
const _hoisted_2 = { class: "material-icons-outlined d-flex justify-content-around align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.props.icon), 1)
  ]))
}